import type { IEditorProps } from "@inputs/text/EditorV2";
import type { RichTextValue } from "@root/types/richText";
import { EditorV2 } from "@styleguide";
import { Controller, type FieldPathByValue, type FieldValues, type UseControllerProps } from "react-hook-form";

type TEditorFormProps<
  TFieldValues extends FieldValues,
  TName extends FieldPathByValue<TFieldValues, RichTextValue | undefined>,
> = UseControllerProps<TFieldValues, TName> &
  Omit<IEditorProps, "value" | "plugins" | "toolbar" | "onInit" | "onChange"> &
  Partial<Pick<IEditorProps, "onChange">> & {
    height?: number;
  };

export const EditorFormV2 = <
  TFieldValues extends FieldValues,
  TName extends FieldPathByValue<TFieldValues, RichTextValue | undefined>,
>({
  control,
  name,
  rules,
  shouldUnregister,
  defaultValue,
  onChange,
  ...editorProps
}: TEditorFormProps<TFieldValues, TName>) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      shouldUnregister={shouldUnregister}
      defaultValue={defaultValue}
      render={({ field: { value, onChange: onChangeForm } }) => (
        <EditorV2
          {...editorProps}
          onChange={(newHtmlValue: string, newTextValue: string) => {
            onChange?.(newHtmlValue, newTextValue);
            onChangeForm({ html: newHtmlValue ?? "", text: newTextValue ?? "" });
          }}
          value={value?.html ?? ""}
        />
      )}
    />
  );
};
